import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Programs from "./pages/Programs";
import Curriculum from "./pages/Curriculum";
import Admissions from "./pages/Admissions";
import Join from "./pages/Join";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import StudentJourney from "./pages/StudentJourney";
import Trinity from "./pages/Trinity";
import SuccessStories from "./pages/SuccessStories";
import ForSchools from "./pages/ForSchools";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import ThankYou from "./pages/ThankYou";
import { SettingsProvider } from "./lib/SettingsContext";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function Layout() {
  return (
    <>
      <Navbar />
      <main className="pt-0">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/student-journey" element={<StudentJourney />} />
          <Route path="/curriculum" element={<Curriculum />} />
          <Route path="/trinity" element={<Trinity />} />
          <Route path="/success-stories" element={<SuccessStories />} />
          <Route path="/for-schools" element={<ForSchools />} />
          <Route path="/admissions" element={<Admissions />} />
          <Route path="/join" element={<Join />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SettingsProvider>
        <ScrollToTop />
        <Routes>
          <Route path="/*" element={<Layout />} />
        </Routes>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0a0a0a",
              border: "1px solid #d4af37",
              color: "#fff",
              fontFamily: "Montserrat, sans-serif",
              borderRadius: 0,
            },
          }}
        />
        </SettingsProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
